export default "__VITE_ASSET__5U3cmfUV__"